

import React, { memo } from 'react';
import { TagInput } from '../../../ui-kit';






function Tags(props) {
  const { onTagChange, tags } = props;

  return (
    <TagInput
      placeholder="Enter some tags"
      onChange={onTagChange}
      defaultValue={tags} />);


}

export default memo(Tags);